var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    name: "status-dot",
    d: "M21.4484 4.19686C21.4484 5.99937 19.9872 7.46061 18.1846 7.46061C16.3821 7.46061 14.9209 5.99937 14.9209 4.19686C14.9209 2.39434 16.3821 0.933105 18.1846 0.933105C19.9872 0.933105 21.4484 2.39434 21.4484 4.19686Z",
    fill: "#FF5F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8238 8.93246C18.9391 9.43641 19 9.96109 19 10.5V15.9995H21.0049V17.9995H3.00488V15.9995H5V10.5C5 6.63401 8.13401 3.5 12 3.5C12.3457 3.5 12.6856 3.52507 13.0179 3.57348C13.0061 3.71408 13 3.85633 13 4C13 4.58434 13.1002 5.14527 13.2845 5.66652C12.8746 5.55789 12.4441 5.5 12 5.5C9.23858 5.5 7 7.73858 7 10.5V15.9995H17V10.5C17 9.91566 16.8998 9.35473 16.7155 8.83348C17.1254 8.94211 17.5559 9 18 9C18.2806 9 18.5558 8.97689 18.8238 8.93246ZM12.0057 21.9995C13.2151 21.9995 14.224 21.1406 14.4556 19.9995H9.55566C9.7873 21.1406 10.7962 21.9995 12.0057 21.9995Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notification-active.cafce1a89b414e55b8b646bde2e12fed.svg";
export { ForwardRef as ReactComponent };